import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import navigationItems from '../../consts/navigationItems';
import theme from '../../common/theme';
// .Header_link .selected,
// .Header_link a:hover {
//   color: #014d9f;
//   font-weight: bolder;
// }

const NavLinkOuter = styled.a`
  &:hover{
    color: ${theme.palette.primary.main};
    font-weight: bolder;
  }
`;

const NavLink = styled(Link)`
  &.${(props) => props.activeClassName}, &:hover {
    color: ${theme.palette.primary.main};
    font-weight: bolder;
  }
`;

const NavigationList = () => (
  <ul className="Header_links">
    {navigationItems.map((navItem) => {
      if (navItem.isOuter) {
        return (
          <li key={navItem.label}>
            <NavLinkOuter
              href={navItem.path}
              target={navItem.target}
              rel="noopener noreferrer"
            >
              {navItem.label}
            </NavLinkOuter>
          </li>
        );
      }
      return (
        <li key={navItem.label}>
          <NavLink to={navItem.path} activeClassName="selected">
            {navItem.label}
          </NavLink>
        </li>
      );
    })}
  </ul>
);

export default NavigationList;
